"use server";

import { signIn } from "@/lib/auth";
import { AuthError } from "next-auth";

export interface SignInResult {
  ok: boolean;
  error?: string;
  mfaRequired?: boolean;
}

export async function signInAction(formData: FormData): Promise<SignInResult> {
  try {
    await signIn("credentials", {
      email: formData.get("email"),
      password: formData.get("password"),
      totp: formData.get("totp") ?? "",
      redirect: false,
    });
    return { ok: true };
  } catch (err) {
    if (err instanceof AuthError) {
      const cause = (err as { cause?: { err?: Error } }).cause?.err;
      if (cause?.message === "MFA_REQUIRED") {
        return { ok: false, mfaRequired: true };
      }
      return { ok: false, error: "Invalid email or password." };
    }
    throw err;
  }
}
